function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import { DEFAULT_INPUT_LENGTH_LIMIT } from "../const";
export var validateMaxCharacterLength = function validateMaxCharacterLength(value, type) {
  var maxLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_INPUT_LENGTH_LIMIT;
  return value.trim().length <= maxLimit || "".concat(type, " can not be more than ").concat(maxLimit, " characters");
};
export var trimFormData = function trimFormData(formData) {
  var trimmedformDataMap = new Map(Object.entries(formData));
  Object.keys(formData).forEach(function (key) {
    var typedKey = key;
    var attributeValue = formData[typedKey];
    if (typeof attributeValue == 'string') {
      trimmedformDataMap.set(typedKey, attributeValue.trim());
    }
  });
  var trimmedFormValues = Object.fromEntries(trimmedformDataMap.entries());
  return trimmedFormValues;
};
export var publishAddNewStudentEvent = function publishAddNewStudentEvent(_ref) {
  var _ref$formData = _ref.formData,
    formData = _ref$formData === void 0 ? undefined : _ref$formData,
    formErrors = _ref.formErrors,
    errorType = _ref.errorType,
    trackEvent = _ref.trackEvent;
  var completed = {
    birthDate: false,
    country: false,
    email: false,
    gender: false,
    leadStatus: false,
    nameFamily: false,
    nameGiven: false,
    nameMiddle: false,
    phoneNumber: false,
    referralSource: false
  };
  if (formData) {
    var formDataMap = {
      birthDate: formData.birthDate,
      country: formData.countryOfCitizenship,
      email: formData.email,
      gender: formData.gender,
      leadStatus: formData.leadStatus,
      nameFamily: formData.lastName,
      nameGiven: formData.firstName,
      nameMiddle: formData.middleName,
      phoneNumber: formData.phoneNumber,
      referralSource: formData.leadSource
    };
    Object.keys(formDataMap).forEach(function (key) {
      var typeSafeKey = key;
      var val = formDataMap[typeSafeKey];
      completed = _objectSpread(_objectSpread({}, completed), {}, _defineProperty({}, typeSafeKey, !!val));
    });
  }
  var data = {
    completed: completed,
    error_type: errorType,
    errors: formErrors
  };
  trackEvent({
    data: data,
    event: 'ANSM - Clicked Create Button',
    group: 'Add New Student Modal'
  });
};
export var getUserAgentInformation = function getUserAgentInformation(currentUser) {
  var _currentUser$included;
  return currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$included = currentUser.included) === null || _currentUser$included === void 0 ? void 0 : _currentUser$included.find(function (includedObj) {
    var _currentUser$relation, _currentUser$relation2, _currentUser$relation3;
    return includedObj.type === 'agent_information' && includedObj.id === ((_currentUser$relation = currentUser.relationships) === null || _currentUser$relation === void 0 ? void 0 : (_currentUser$relation2 = _currentUser$relation.agent_information) === null || _currentUser$relation2 === void 0 ? void 0 : (_currentUser$relation3 = _currentUser$relation2.data) === null || _currentUser$relation3 === void 0 ? void 0 : _currentUser$relation3.id);
  });
};
export var redirectToStudentsPage = function redirectToStudentsPage(history, location) {
  // We need to consider the fact that if the user is already in the /students page,
  // and the history is replaced with the same path (/students), the list of students
  // will not be re-fetched. In such cases, we add an extra param of _refetchStudents=t
  // which is handled by the Student component to re-fetch the list of students. The param
  // is removed from the URL after the list is re-fetched.
  if (location.pathname == '/students') {
    var currentUrlParams = new URLSearchParams(location.search);
    currentUrlParams.append('_refetchStudents', 't');
    history.push({
      pathname: location.pathname,
      search: currentUrlParams.toString()
    });
  } else {
    history.push('/students');
  }
};